<template>
    <v-card>
        <v-card-title>
            <v-row>
                <v-col cols="12" sm="6" class="ma-2">
                    Samples for {{ experiment.code }} on {{ date }}
                </v-col>
                <v-col cols="12" sm="6" class="text-end">
                    <v-btn
                        color="error"
                        class="ma-2"
                        @click="deleteSelected()"
                        v-if="deleteEnabled"
                    >
                        Delete ({{ selectedSamples.length }})
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-title>
        <v-data-table
            :headers="sampleHeaders"
            :items="samples"
            item-key="id"
            no-results-text="No samples have been collected for this date."
            class="elevation-1"
            :show-select="deleteEnabled"
            :multi-select="deleteEnabled"
            v-model="selectedSamples"
            return-object
            :items-per-page="25"
        >
            <template v-slot:item.data="{ item }">
                {{ item.data ? item.data : "No Data" }}
            </template>
        </v-data-table>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="cancel"> Close </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { defineComponent } from "vue";

import { fetchSamplesByExperimentAndDate, clearSampleData } from "@/services/samples/samplesAPI";
import { withLoadingScreen } from "@/lib/loading";
import { mapGetters } from "vuex";

export default defineComponent({
    name: "ExperimentSamples",

    props: {
        experiment: { type: Object },
        date: { type: String },
    },

    data() {
        return {
            sampleHeaders: [
                {
                    title: "ID",
                    value: "id",
                    align: "left",
                    sortable: true,
                },
                {
                    title: "Sample ID",
                    value: "sampleID",
                    align: "left",
                    sortable: true,
                },
                {
                    title: "Functional Key",
                    value: "functionalKey",
                    align: "left",
                    sortable: true,
                },
                {
                    title: "Sample Type",
                    value: "sampleType",
                    align: "left",
                    sortable: true,
                },
                {
                    title: "Sample Text",
                    value: "sampleText",
                    align: "left",
                    sortable: true,
                },
                {
                    title: "Sample Data",
                    value: "data",
                    align: "left",
                    sortable: false,
                },
                {
                    title: "Source Type",
                    value: "sourceType",
                    align: "left",
                    sortable: true,
                },
                {
                    title: "Source Name",
                    value: "sourceName",
                    align: "left",
                    sortable: true,
                },
                {
                    title: "Sample Protocol",
                    value: "protocolName",
                    align: "left",
                    sortable: true,
                },
            ],
            samples: [],
            selectedSamples: [],
        };
    },

    computed: {
        ...mapGetters(["isAuthorized"]),
        deleteEnabled() {
            return this.isAuthorized("Samples:Update");
        },
    },

    async created() {
        await this.fetchSamples();
    },

    methods: {
        async fetchSamples() {
            withLoadingScreen(async () => {
                const samples = await fetchSamplesByExperimentAndDate(
                    this.experiment.code,
                    this.date
                );
                this.samples = samples;
            });
        },
        cancel() {
            this.$emit("close");
        },
        async deleteSelected() {
            if (this.selectedSamples.length === 0) {
                return;
            }
            const ids = this.selectedSamples.map((sample) => sample.id);
            await clearSampleData(ids);
            this.selectedSamples = [];
            await this.fetchSamples();
        },
    },
});
</script>

<style></style>
